import * as AC from './actionTypes';

export const getElevators = (filters = {}) => ({
  type: AC.GET_ELEVATORS_REQUEST,
  filters,
});

export const getAllElevators = (filters = {}) => ({
  type: AC.GET_ALL_ELEVATORS_REQUEST,
  filters,
});

export const getInactiveElevators = (filters = {}) => ({
  type: AC.GET_INACTIVE_ELEVATORS_REQUEST,
  filters,
});

export const getElevatorsByBuilding = (buildingId, filters = {}) => ({
  type: AC.GET_BUILDING_ELEVATORS_REQUEST,
  buildingId,
  filters,
});

export const getElevatorsByEntrance = (entranceId, filters = {}) => ({
  type: AC.GET_ENTRANCE_ELEVATORS_REQUEST,
  entranceId,
  filters,
});

export const getElevatorDetails = id => ({
  type: AC.GET_ELEVATOR_DETAILS_REQUEST,
  id,
});

export const addElevator = (
  name,
  imei,
  entranceId,
  phoneNumber,
  buildingId,
  category,
  elevator_id
) => ({
  type: AC.ADD_ELEVATOR_REQUEST,
  payload: {
    name,
    imei,
    entranceId,
    phoneNumber,
    category,
    elevator_id,
  },
  buildingId,
});

export const editElevator = (
  name,
  imei,
  entranceId,
  phoneNumber,
  buildingId,
  category,
  elevator_id,
  id,
) => ({
  type: AC.EDIT_ELEVATOR_REQUEST,
  payload: {
    name,
    imei,
    entranceId,
    phoneNumber,
    category,
    elevator_id,
    id,
  },
  buildingId,
});

export const deleteElevator = id => ({
  type: AC.DELETE_ELEVATOR_REQUEST,
  id,
});

export const getElevatorConfigurations = id => ({
  type: AC.GET_ELEVATOR_CONGIFURATIONS_REQUEST,
  id,
});

export const configureElevator = (
  id,
  imei,
  notes,
  relay1Delay,
  relay2Delay,
  relay3Delay,
  relay4Delay,
  relay5Delay,
  relay6Delay,
  relay7Delay,
  relay8Delay,
  relay9Delay,
  relay10Delay,
  relay11Delay,
  relay12Delay,
  relay13Delay,
  relay14Delay,
  relay15Delay,
  relay16Delay,
  sms_username = '',
  sms_password = '',
) => ({
  type: AC.CONFIGURE_ELEVATOR_REQUEST,
  id,
  payload: {
    imei,
    notes,
    relay1Delay,
    relay2Delay,
    relay3Delay,
    relay4Delay,
    relay5Delay,
    relay6Delay,
    relay7Delay,
    relay8Delay,
    relay9Delay,
    relay10Delay,
    relay11Delay,
    relay12Delay,
    relay13Delay,
    relay14Delay,
    relay15Delay,
    relay16Delay,
  },
  sms_username,
  sms_password,
});
